/* eslint-disable simple-import-sort/imports */
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { L10n } from '~src/ts/L10n/L10n';
import { IResourceGovernanceServerSettings } from '../types/ResourceGovernance';
export namespace GovLimitsCardTestIds {
    export const ConcurrentJobsLimitsHeader = 'concurrentJobsLimitsHeader';
    export const DailyJobsLimitsHeader = 'dailyJobsLimitsHeader';
    export const ConcurrentJobsSectionHeaders = 'concurrentJobsSectionHeaders';
    export const ConcurrentJobsSectionValues = 'concurrentJobsSectionValues';
    export const DailyLimitsSectionHeaders = 'dailyLimitsSectionHeaders';
    export const DailyLimitsSectionValues = 'dailyLimitsSectionValues';
}

const headerStyle: React.CSSProperties = {
    paddingLeft: 5,
    paddingRight: 5,
    fontWeight: 'normal'
};

const valueStyle: React.CSSProperties = {
    paddingLeft: 5,
    paddingRight: 5,
    fontWeight: 'bold'
};

const tableStyle: React.CSSProperties = {
    display: 'inline-table',
    tableLayout: 'fixed',
    marginLeft: 8,
    border: 'solid',
    borderColor: CommonStyles.Colors.Grey230
};

export function SchedulesGovernanceLimitsCard(props: IResourceGovernanceServerSettings) {
    const NO_LIMIT = Messages.resourceGovernanceNoLimitValue();
    const {extractsConcurrencyLimit, subscriptionsConcurrencyLimit, flowsConcurrencyLimit, runtimeLimit, nextResetAt} = props;
    return (
        <div className="tb-indent" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 15}}>
            <span className="tb-settings-group-name" data-tb-test-id={GovLimitsCardTestIds.ConcurrentJobsLimitsHeader} style={{ fontWeight: 'normal', paddingBottom: 0 }}>
                {Messages.resourceGovernanceConcurrentJobsLimitsHeader()}
            </span>
            <table style={ tableStyle } >
                <thead data-tb-test-id={GovLimitsCardTestIds.ConcurrentJobsSectionHeaders} >
                    <tr>
                        <td style={ headerStyle }>
                            {Messages.resourceGovernanceSubscriptionsHeader()}
                        </td>
                        <td style={ headerStyle }>
                            {Messages.resourceGovernanceExtractsHeader()}
                        </td>
                        <td style={ headerStyle }>
                            {Messages.resourceGovernanceFlowsHeader()}
                        </td>
                    </tr>
                </thead>
                <tbody data-tb-test-id={GovLimitsCardTestIds.ConcurrentJobsSectionValues} >
                    <tr>
                        <td style={ valueStyle }>
                            {subscriptionsConcurrencyLimit !== undefined
                              ? L10n.localizedCount(subscriptionsConcurrencyLimit)
                              : NO_LIMIT}
                        </td>
                        <td style={ valueStyle }>
                            {extractsConcurrencyLimit !== undefined
                              ? L10n.localizedCount(extractsConcurrencyLimit)
                              : NO_LIMIT}
                        </td>
                        <td style={ valueStyle }>
                            {flowsConcurrencyLimit !== undefined
                              ? L10n.localizedCount(flowsConcurrencyLimit)
                              : NO_LIMIT}
                        </td>
                    </tr>
                </tbody>
            </table>
            <span className="tb-settings-group-name" data-tb-test-id={GovLimitsCardTestIds.DailyJobsLimitsHeader} style={{ fontWeight: 'normal', paddingBottom: 0, paddingLeft: 15 }}>
                {Messages.resourceGovernanceDailyJobsLimitsHeader()}
            </span>
            <table style={ tableStyle }>
                <thead data-tb-test-id={GovLimitsCardTestIds.DailyLimitsSectionHeaders}>
                    <tr>
                        <td style={ headerStyle }>
                            {Messages.resourceGovernanceRuntimeHeader()}
                        </td>
                        <td style={ headerStyle }>
                            {Messages.resourceGovernanceResetHeader()}
                        </td>
                    </tr>
                </thead>
                <tbody data-tb-test-id={GovLimitsCardTestIds.DailyLimitsSectionValues}>
                    <tr>
                        <td style={ valueStyle }>
                            {runtimeLimit !== undefined
                              ? Messages.resourceGovernanceColumnRuntimeHours({RUNTIME: L10n.localizedCount(runtimeLimit)})
                              : NO_LIMIT}
                        </td>
                        <td style={ valueStyle }>
                            { Messages.resourceGovernanceMidnightUTC() }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
